import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import PrivateOutlet from './PrivateOutlet';
import VEXFooter from './VEXFooter';
import ReactGA from 'react-ga';

const Authentication = lazy(() => import("./Authentication"));
const Home = lazy(() => import("./Home"));
const Login = lazy(() => import("./Login"));
const Licenses = lazy(() => import("./Licenses"));
const Offline = lazy(() => import("./Offline"));
const Services = lazy(() => import("./Services"));
const Classes = lazy(() => import("./Classes"));
const Analytics = lazy(() => import("./Analytics"));

ReactGA.initialize('G-V43HTX3MN6');

function App() {
  return (
    <Router>
      <div className="app-wrapper">
      <Suspense fallback={<div>Loading...</div>}>
        <main id="main-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/redirect" element={<Authentication />} />
          <Route element={<PrivateOutlet />}>
            <Route path="/:platform/auth/redirect" element={<Services />} />
            <Route path="/:platform/auth/redirect" element={<Services />} />
            <Route path="/home" element={<Home />}></Route>
            <Route path="/licenses" element={<Licenses />}></Route>
            <Route path="/classes" element={<Classes />}></Route>
            <Route path="/service" element={<Services />}></Route>
            <Route path="/analytics" element={<Analytics />}></Route>
            <Route path="/offline" element={<Offline />}></Route>
          </Route>
          <Route path="/" element={<Navigate to="/home" />} />
        </Routes>
        </main>
        <VEXFooter></VEXFooter>
        </Suspense>
      </div>
    </Router>
  );
}

export default App
